import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class PartSearchService {

    createMultiStringParams(params: string[]): string[] {
        return params.map(el => `$and:$ilike:${el}`);
    }

    createMultiParams(params: string[]): string[] {
        return params.map(el => el);
    }
}
